import { reactive } from 'vue';

export const globalState = reactive({
  currentUser: localStorage.getItem('arch_current_user') || ''
});

export const loginUser = (username: string) => {
  globalState.currentUser = username;
  localStorage.setItem('arch_current_user', username);
};

export const logoutUser = () => {
  globalState.currentUser = '';
  localStorage.removeItem('arch_current_user');
};
